function Privacy() {
  return (
    <div className="privacy container" style={{ minHeight: "85vh" }}>
      <h1>Privacy Policy</h1>

      <p>
        At the Rubber Ducky Blog, we're all about keeping things simple and
        making you smile. That's why our privacy policy is short and sweet, just
        like a rubber ducky in a kiddie pool.
      </p>

      <p>
        We don't ask for your name, email address, or any other information that
        could be used to identify you. We don't use cookies, tracking
        technologies, or any other methods to gather information about your
        visit to our site. We don't share your information with third parties,
        unless you're a rubber duck and want to be included in our rubber duck
        directory (in which case, please contact us directly).
      </p>

      <p>
        We do our best to keep the Rubber Ducky Blog secure, but we can't
        guarantee that it will be 100% secure. So if you have sensitive
        information, you may want to keep it to yourself.
      </p>

      <p>
        Our Privacy Policy may change from time to time, but rest assured that
        we will never collect any personal information from you.
      </p>

      <p>
        If you have any questions or concerns about our Privacy Policy, feel
        free to drop us a line at [insert your email address]. But remember,
        this is the Rubber Ducky Blog, so don't take anything too seriously.
      </p>
    </div>
  );
}

export default Privacy;
